import { FC, PropsWithChildren, ReactElement } from 'react';
import styled from 'styled-components';

import { scrollBarStyles } from '@/utils/theme';

const Wrap = styled.div`
  border: 1px solid rgba(242, 243, 247, 1);
  border-radius: 4px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.white};
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  ${scrollBarStyles};
`;

const Header = styled.div`
  margin-bottom: 16px;
`;

interface Props {
  header?: ReactElement | null;
  className?: string;
}

const Card: FC<PropsWithChildren<Props>> = ({
  children,
  header,
  className,
}) => {
  return (
    <Wrap className={className}>
      {!!header && <Header>{header}</Header>}
      {children}
    </Wrap>
  );
};

export default Card;
